import { useCallback } from "react";
import {
  CasinoActionCreators,
  RealityCheckActionCreators
} from "../redux/action-creators";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CasinoSelectors } from "../redux/selectors";
import emptyState from "../redux/store/emptyState";
import { AppFeatures } from "../constants/featureFlags";
import { useFeature } from "./useFeature";
import { MessageBrokerUtils, TrackingUtils } from "../utils";
import { Channel, DialogType, Topic } from "../constants";

export const useLogout = () => {
  const dispatch = useDispatch();
  const isLugasLogoutActive = useFeature(AppFeatures.LUGAS_LOGOUT);
  const gamblingSession = useSelector(CasinoSelectors.gamblingSession);

  const resetGamblingSession = useCallback(() => {
    dispatch(
      CasinoActionCreators.setGamblingSession(emptyState.casino.gamblingSession)
    );
  }, [dispatch]);

  const resetSportSessionDetails = useCallback(() => {
    dispatch(
      RealityCheckActionCreators.setSportSessionDetails(
        emptyState.realityCheck.sportSessionDetails
      )
    );
  }, [dispatch]);

  const showLogoutPopup = () => {
    if (gamblingSession.sessionStatus === 1) {
      TrackingUtils.sendAnalytics({
        dataCategory: "Logout popup",
        dataAction: "view",
        dataLabel: "Casino session summary"
      });
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: {
          dialogType: DialogType.CasinoSessionSummary,
          options: gamblingSession
        }
      });
    } else if (isLugasLogoutActive) {
      TrackingUtils.sendAnalytics({
        dataCategory: "Logout popup",
        dataAction: "view",
        dataLabel: "Lugas logout"
      });
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: { dialogType: DialogType.LugasLogout }
      });
    } else {
      TrackingUtils.sendAnalytics({
        dataCategory: "Logout popup",
        dataAction: "view",
        dataLabel: "Logout"
      });
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: { dialogType: DialogType.Logout }
      });
    }
  };

  return { resetGamblingSession, resetSportSessionDetails, showLogoutPopup };
};
